import React, {useState} from 'react';
import { useFormContext } from './Provider';
import Loading from '../Loading';
import { useModalContext } from '../Modal/Provider';
import { classNames } from '../../Services/helpers';

const Actions = ({submit, cancel, extra, left}) => {
    const {isSubmitting, setFormData} = useFormContext();
    const modalContext = useModalContext();
    const [extraLoading, setExtraLoading] = useState(false);

    let _submit = null;
    if (submit === true) {
        _submit = {
            label: 'Submit',
            btnRef: null,
        }
    } else if (submit) {
        _submit = submit;
    }

    const handleCancel = (e) => {
        e.preventDefault();
        if (cancel.back) {
            window.history.back();
        } else if (cancel.clear) {
            setFormData({});
        } else if (cancel.onClick) {
            cancel.onClick();
        }
        if (modalContext) {
            modalContext.closeModal();
        }
    }

    const handleExtra = (e) => {
        e.preventDefault();
        if (extra.onClick) {
            setExtraLoading(true);
            const extraPromise = extra.onClick();
            Promise.resolve(extraPromise).then(() => setExtraLoading(false));
        }
        if (extra.closeModal && modalContext) {
            modalContext.closeModal();
        }
    }

    return <div className="flex flex-row justify-between">
        <div>
            {left}
        </div>
        <div>
            {extra && <button type="button"
                ref={extra.btnRef}
                className={classNames('my-3 ml-3 btn', extra.className)}
                disabled={extra.disabled || isSubmitting || extraLoading}
                onClick={handleExtra}
            >
                {extraLoading && <Loading className="mr-2" />}
                {extra.label}
            </button>}

            {cancel && <button type="button"
                ref={cancel.btnRef}
                className="my-3 ml-3 btn btn-secondary"
                disabled={isSubmitting || extraLoading}
                onClick={handleCancel}
            >
                {cancel.label ?? 'Cancel'}
            </button>}

            {_submit && <button type="submit"
                ref={_submit.btnRef}
                className="my-3 ml-3 btn btn-primary"
                disabled={isSubmitting || extraLoading}
            >
                {isSubmitting && <Loading className="mr-2" bg="dark" />}
                {submitLabel(_submit, isSubmitting)}
            </button>}
        </div>
    </div>;
}

const submitLabel = (_submit, isSubmitting) => {
    if (isSubmitting && _submit.hideLabelWhileSubmitting) {
        return null;
    }

    return _submit.label ?? 'Submit';
}



export default Actions;
